/* PAPPOS — línea de envío gratis y meses sin intereses debajo del precio (snippet pp-ship-line).
   Recalcula con el carrito real (/cart.js): al cargar, al cambiar de talla y cada vez que se pinta el carrito lateral.
   Cupones: toma la lista de window.ppCoupon (sección pp-coupon). Un cupón de envío gratis con monto («desde $679»)
   baja el mínimo; un cupón de porcentaje («15% de bienvenida») baja el precio con el que se calcula. */
(() => {
  if (customElements.get('pp-ship-line')) return;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const money = (cents) => '$ ' + (cents / 100).toLocaleString('es-MX', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  const up = (cents) => Math.ceil(cents / 100) * 100;
  const isShip = (name) => /env[ií]o\s+gratis/i.test(name || '');
  const minOf = (rule) => {
    const m = String(rule || '').replace(/,/g, '').match(/\$\s*(\d+(?:\.\d+)?)/);
    return m ? Math.round(parseFloat(m[1]) * 100) : 0;
  };
  const ICON = {
    check: '<svg class="pp-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
    truck: '<svg class="pp-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17" cy="17.5" r="1.6"/></svg>'
  };

  let pending = null;
  const getCart = () => {
    if (!pending) {
      pending = fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then((r) => (r.ok ? r.json() : null)).catch(() => null)
        .finally(() => { setTimeout(() => { pending = null; }, 0); });
    }
    return pending;
  };

  /* Cupones del carrito que están en la lista de pp-coupon. */
  function coupons(cart) {
    const known = (window.ppCoupon && window.ppCoupon.codes) || {};
    const out = { shipMin: 0, pct: 0 };
    ((cart && cart.discount_codes) || []).forEach((d) => {
      const k = known[String(d.code || '').toUpperCase()];
      if (!k) return;
      if (isShip(k.name)) {
        const m = minOf(k.rule);
        if (m > 0 && (!out.shipMin || m < out.shipMin)) out.shipMin = m;
      } else {
        const p = String(k.name || '').match(/(\d+(?:\.\d+)?)\s*%/);
        if (p) out.pct = Math.max(out.pct, parseFloat(p[1]));
      }
    });
    return out;
  }

  class PPShipLine extends HTMLElement {
    connectedCallback() {
      this.base = Number(this.dataset.threshold) || 0;
      this.price = Number(this.dataset.price) || 0;
      this.pid = Number(this.dataset.product);
      try { this.tiers = JSON.parse(this.dataset.msi || '[]'); } catch (e) { this.tiers = []; }
      const section = this.dataset.section;
      const form = document.querySelector('pp-product-form[data-section="' + section + '"]');
      const json = form && form.querySelector('script[data-pp-variants]');
      try { this.variants = json ? JSON.parse(json.textContent) : []; } catch (e) { this.variants = []; }
      this.idInput = form && form.querySelector('form [name=id]');
      this.sticky = document.querySelector('[data-pp-sticky-sub="' + section + '"]');

      /* Talla o color: el formulario actualiza el id de la variante; se lee después. */
      if (form) form.addEventListener('change', (e) => {
        if (!e.target.matches('[data-pp-option]')) return;
        setTimeout(() => {
          const v = this.variants.find((x) => String(x.id) === String(this.idInput && this.idInput.value));
          if (v && typeof v.price === 'number' && v.price !== this.price) { this.price = v.price; this.paint(); }
        }, 0);
      });

      /* Carrito lateral: se vuelve a pintar (Section Rendering) al agregar o cambiar cantidades. */
      const panel = document.querySelector('#pp-cart .pp-drawer__panel');
      if (panel && 'MutationObserver' in window) {
        let t;
        new MutationObserver(() => { clearTimeout(t); t = setTimeout(() => this.refresh(), 60); }).observe(panel, { childList: true });
      }
      window.addEventListener('pageshow', (e) => { if (e.persisted) this.refresh(); });
      this.refresh();
    }

    async refresh() {
      const cart = await getCart();
      if (!cart) return;
      this.cart = cart;
      this.paint();
    }

    paint() {
      const cart = this.cart || { total_price: 0, items: [], discount_codes: [] };
      const c = coupons(cart);
      const thr = c.shipMin && (!this.base || c.shipMin < this.base) ? c.shipMin : this.base;
      const viaCoupon = thr !== this.base;
      const price = c.pct ? Math.round(this.price * (1 - c.pct / 100)) : this.price;
      const total = cart.total_price || 0;
      const inCart = (cart.items || []).some((i) => i.product_id === this.pid);
      const thrTxt = money(thr);
      const free = viaCoupon ? 'Envío gratis con tu cupón' : 'Envío gratis';
      const from = (viaCoupon ? 'Envío gratis con tu cupón desde ' : 'Envío gratis desde ') + thrTxt;

      let ok = false; let main = ''; let sub = '';
      if (thr > 0) {
        if (price >= thr) {
          ok = true; main = free;
          sub = this.dataset.delivery ? 'Llega en ' + this.dataset.delivery : '';
        } else if (total >= thr) {
          ok = true; main = viaCoupon ? 'Tu envío ya es gratis con tu cupón' : 'Tu envío ya es gratis';
          sub = 'Tu carrito ya pasa de ' + thrTxt;
        } else if (total > 0 && !inCart) {
          if (total + price >= thr) {
            ok = true; main = 'Agrégalo y tu envío es gratis';
            sub = 'Sumado a los ' + money(total) + ' que ya llevas en tu carrito';
          } else {
            main = from; sub = 'Con este y tu carrito te faltarían ' + money(up(thr - total - price));
          }
        } else if (inCart) {
          main = from; sub = 'Te faltan ' + money(up(thr - total)) + ' con lo que llevas en tu carrito';
        } else {
          main = from; sub = 'Con este producto te faltarían ' + money(up(thr - price));
        }
      }

      const row = this.querySelector('[data-pp-ship-row]');
      if (row && main) {
        row.classList.toggle('is-ok', ok);
        const ic = row.querySelector('[data-pp-ship-ic]');
        if (ic) ic.innerHTML = ok ? ICON.check : ICON.truck;
        const m = row.querySelector('[data-pp-ship-main]');
        const s = row.querySelector('[data-pp-ship-sub]');
        if (m) m.textContent = main;
        if (s) { s.textContent = sub; s.hidden = !sub; }
      }

      /* Barra fija de compra en móvil: «Envío gratis» solo si de verdad aplica. */
      if (this.sticky) {
        const showing = this.sticky.textContent === (this.sticky.dataset.base || '');
        this.sticky.dataset.base = ok ? 'Envío gratis' : '';
        if (showing) this.sticky.textContent = this.sticky.dataset.base;
      }

      /* Meses sin intereses: el plazo más largo al que llega el precio ya con el cupón de porcentaje, que es lo que se cobra. */
      const msi = this.querySelector('[data-pp-msi]');
      if (msi && this.tiers.length) {
        let months = 0;
        this.tiers.forEach(([min, mo]) => { if (price >= min && mo > months) months = mo; });
        msi.hidden = !months;
        const tx = msi.querySelector('[data-pp-msi-tx]');
        if (tx && months) tx.innerHTML = 'o hasta <b>' + months + ' meses sin intereses</b> de ' + money(Math.floor(price / months)) + ' con tarjeta de crédito';
      }
    }
  }
  customElements.define('pp-ship-line', PPShipLine);
})();
